import axios from 'axios';

export default {
  sources() {
    return axios.get('/resources/sources');
  },
  skills() {
    return axios.get('/resources/skills');
  },
  skillStacks() {
    return axios.get('/resources/skill-stacks');
  },
  countries() {
    return axios.get('/resources/countries');
  },
  industries() {
    return axios.get('/resources/industries');
  },
};
